export default __webpack_public_path__ + "static/media/document-right.4a21c8a0.svg";